import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Alert } from '@/shared/components/ui/alert/alert';
import { useDateUtils } from '@/shared/hooks/use-date-utils/use-date-utils';
import {
  selectMaintenanceAlertOpen,
  setMaintenanceAlertOpen,
} from '@/shared/redux/api/auth/auth-api';
import { useAppDispatch, useAppSelector } from '@/shared/redux/hooks/hooks';

const MAINTENANCE_DATE_ISO = '2026-03-16T20:00:00.000Z';

export const MaintenanceAlert = () => {
  const { t } = useTranslation();
  const { formatLocalTime } = useDateUtils();
  const maintenanceAlertOpen = useAppSelector(selectMaintenanceAlertOpen);
  const dispatch = useAppDispatch();

  if (!maintenanceAlertOpen) {
    return null;
  }

  return (
    <Box marginBottom="1.5rem" className="maintenance-alert">
      <Alert
        color="yellow"
        text={t('common:alert.maintenance', {
          localTime: formatLocalTime(MAINTENANCE_DATE_ISO),
          utcTime: `${formatLocalTime(MAINTENANCE_DATE_ISO, 'UTC')} UTC`,
        })}
        onClose={() => dispatch(setMaintenanceAlertOpen(false))}
      />
    </Box>
  );
};
